function validate(schema, value) {
  const result = schema.safeParse(value);
  if (result.success) {
    return result.data;
  }
  console.warn("Zod validation error", result.error.issues, value);
  return null;
}
export {
  validate
};
//# sourceMappingURL=validate.js.map
